import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { formatImcNumber } from '../../app/utils/formatImcNumber';
import { PCSDetailsDto } from '../../app/models/pcsEnrolment/pcsDetailsDto';
import { RegistrationType } from '../../app/models/staticData/registrationType';
import { Scheme } from '../../app/models/staticData/scheme';

const styles = StyleSheet.create({
    titleContainer: {
        flexDirection: 'row',
        marginTop: 5,
        fontSize: 9,
        fontFamily: 'Helvetica'
    },
    fieldLeft: {
        width: '30%'
    },
    fieldRight: {
        width: '40%'
    }
});

interface Props {
    registrationDetails: PCSDetailsDto | null;
    schemes: Scheme[] | null;
    registrationTypes: RegistrationType[] | null;
    personName: string;
}

const LegacyReceiptItems = ({ registrationDetails, schemes, registrationTypes, personName }: Props) => {
    return (<>
        <View style={styles.titleContainer}>
            <Text style={styles.fieldLeft}>
                Name
            </Text>

            <Text style={styles.fieldRight}>
                {personName}
            </Text>
        </View>

        <View style={styles.titleContainer}>
            <Text style={styles.fieldLeft}>
                Medical Council Number
            </Text>

            <Text style={styles.fieldRight}>
                {formatImcNumber(registrationDetails?.imcNumber)}
            </Text>
        </View>

        <View style={styles.titleContainer}>
            <Text style={styles.fieldLeft}>
                Scheme
            </Text>

            <Text style={styles.fieldRight}>
                {schemes?.find(x => x.id === registrationDetails?.schemeId)?.value}
            </Text>
        </View>

        <View style={styles.titleContainer}>
            <Text style={styles.fieldLeft}>
                Registration Type
            </Text>

            <Text style={styles.fieldRight}>
                {registrationTypes?.find(x => x.id === registrationDetails?.registrationTypeId)?.value}
            </Text>
        </View>
    </>)
}

export default LegacyReceiptItems;
